import { useQuery } from '@tanstack/react-query';
import { config, isBffConfigured } from '../../config';

export interface BackendMe {
  email: string;
  name: string;
  isAdmin: boolean;
}

async function fetchMe(): Promise<BackendMe> {
  const { oktaAuth } = await import('../../auth/OktaProvider');
  if (!oktaAuth) throw new Error('Okta not configured');
  const token = await oktaAuth.getOrRenewAccessToken();
  if (!token) throw new Error('No access token');
  const res = await fetch(`${config.bffUrl}/prototyper/me`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) throw new Error(`GET /prototyper/me ${res.status}`);
  return res.json() as Promise<BackendMe>;
}

export function useBackendMe(): { email: string | undefined; isAdmin: boolean } {
  const { data } = useQuery({
    queryKey: ['backendMe'],
    queryFn: fetchMe,
    enabled: isBffConfigured(),
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });
  return { email: data?.email, isAdmin: data?.isAdmin ?? false };
}
